/**
 * WorkflowDefinitionFilter - Filtro rápido "Processo" das páginas do Workflow
 *
 * Reaproveita `useWorkflowOverview` (mesma fonte da página Processos) e o
 * estilo pill padrão das barras de filtro.
 *
 * @version 1.0.0
 * RELEASE: 2026-10-06 v1.0.0 - Criação inicial (submenus do Workflow).
 */

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { QUICK_FILTER_PILL } from '@/components/layout/list-page/quickFilterStyles';
import { useWorkflowOverview } from '@/hooks/useWorkflowDesigner';
import { cn } from '@/lib/utils';

interface Props {
  /** Processo selecionado (null = todos) */
  value: string | null;
  onChange: (id: string | null) => void;
}

export function WorkflowDefinitionFilter({ value, onChange }: Props) {
  const { overview } = useWorkflowOverview();
  const definicoes = overview?.definitions ?? [];

  return (
    <Select value={value ?? 'todos'} onValueChange={(v) => onChange(v === 'todos' ? null : v)}>
      <SelectTrigger className={cn(QUICK_FILTER_PILL, 'w-auto min-w-[150px]')}>
        <SelectValue placeholder="Processo" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="todos">Todos os processos</SelectItem>
        {definicoes.map((d) => (
          <SelectItem key={d.id} value={d.id}>
            {d.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
